import { purchaseSeats } from '../../../services/customer/ticketBookingServices';
import { bankTypeToCountry } from '../../constants';
import showErrorMessageModal
  from '../../../components/customer/components/modals/showErrorMessageModal/showErrorMessageModal';
import submit3DSecureChallenge from './submit3DSecureChallenge';

async function handlePurchaseSeats({
  id, guid, countryCode, payment_card, setIsNextDisabled, payment_bank,
}) {
  setIsNextDisabled(true);
  try {
    const bank_type = payment_bank || bankTypeToCountry?.[countryCode];
    const res = await purchaseSeats(id, guid, {
      ...(bank_type && {
        bank_type,
      }),
      ...(payment_card && {
        payment_card,
      }),
    });
    if (res?.data?.acs_url && res?.data?.acs_cer) {
      submit3DSecureChallenge(res?.data?.acs_url, res?.data?.acs_cer);
    } else if (res?.data?.form_submit_payment?.url) {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = res?.data?.form_submit_payment?.url;

      // eslint-disable-next-line no-restricted-syntax
      for (const key in res?.data?.form_submit_payment) {
        if (key !== 'url') {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = res?.data?.form_submit_payment[key];
          form.appendChild(input);
        }
      }

      document.body.appendChild(form);
      form.submit();
    } else if (res.status === 'success') {
      window.location.replace(res.data.payment_url);
      setIsNextDisabled(false);
    }
  } catch {
    setIsNextDisabled(false);
  }
}

export default async function purchaseBookedTickets({
  id, guid, countryCode, payment_card, trans, setIsNextDisabled, payment_bank,
}) {
  if (payment_card) {
    handlePurchaseSeats({
      id, guid, countryCode, payment_card, setIsNextDisabled, payment_bank,
    });
  } else {
    showErrorMessageModal({
      errorText: trans('statement_active_text'),
      onOk: () => {
        handlePurchaseSeats({
          id, guid, countryCode, payment_card, setIsNextDisabled, payment_bank,
        });
      },
      onClose: () => {
        handlePurchaseSeats({
          id, guid, countryCode, payment_card, setIsNextDisabled, payment_bank,
        });
      },
    });
  }
}
